import { type ReactNode, useEffect } from 'react'
import { X } from 'lucide-react'
import styles from './Modal.module.css'

interface Props {
  aperto: boolean
  titolo?: ReactNode
  onChiudi: () => void
  larghezzaMax?: number
  children: ReactNode
}

export function Modal({ aperto, titolo, onChiudi, larghezzaMax = 480, children }: Props) {
  useEffect(() => {
    if (!aperto) return
    const onEsc = (e: KeyboardEvent) => { if (e.key === 'Escape') onChiudi() }
    document.addEventListener('keydown', onEsc)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onEsc)
      document.body.style.overflow = ''
    }
  }, [aperto, onChiudi])

  if (!aperto) return null
  return (
    <div className={styles.backdrop} onClick={onChiudi}>
      <div
        className={styles.dialog}
        style={{ maxWidth: larghezzaMax }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.header}>
          <h3>{titolo}</h3>
          <button className={styles.close} onClick={onChiudi} aria-label="Chiudi">
            <X size={18} />
          </button>
        </div>
        <div className={styles.body}>{children}</div>
      </div>
    </div>
  )
}
